import React, {createRef, useState, useRef, useEffect} from 'react';
import { Helmet } from 'react-helmet-async'
import { useHistory } from "react-router-dom";

import backIconImg from "images/icon/back_icon-24x24.png";
import shareIcon from "images/icon/share_icon-24x24.png";
import closeIcon from "images/icon/close_icon-24x24.png";
import bellIconImg from "images/icon/bell_icon-24x24.png";
import moreIconImg from "images/icon/more_icon-24x24.png";

// import arrowIconImg from 'images/arrow_icon.png'
// import shareIcon from 'images/share_icon.png'
// import closeIcon from 'images/close_icon.png'
import exitIcon from 'images/leave_icon-18x19.png'
// import bellIconImg from 'images/icon/bell_icon-35×39.png'; 
import onMatchingIcon from 'images/icon/on_matching_icon-21x21.png'

import KakaoShareButton from 'components/containers/common/KakaoShareButton'
import { 
    HeaderWrapper,
    TopInner, TitleTxt, 
    Title, Back, Share, 
    BackButtonarea, Buttonarea, 
    CloseBtnArea, CloseBtnWrapper, 
    CompleteBtn, DisabledCompleteBtn, 
    ExitBtn, ExitBtnImg, BellLink, Alarm,
    MatchingBtn, ButtonIcon, MatchingButtonBlock,
    IconImg, More,
} from './style';
import DotButton from 'components/presenters/button/DotButton';
import { useSelector } from 'react-redux';

export default function AnimatedWindowHeader({onBackBtn, borderbottom,background,title, isShare , shareQueryString, shareTitle, shareDescription, shareImg, isCloseBtn, prevURL, isDotBtn, handleModalState, showComplete, isComplete, onCompleteClick, showExitBtn, onExit, animation, isSlideOn, isNotiBtn, newAlarmExist, isMatchingBtn=true }) {
    const animationClassName = animation && (isSlideOn !== null || isSlideOn !== undefined) ? ( isSlideOn === true ? 'slide_on' : 'slide_out') : null;
    const userInfo = useSelector((state) => {
        return state['userInfo'];
    })
    const kakaoButton = createRef();
    const history = useHistory();
    const goBack = () =>{
        if(onBackBtn)
        {
            onBackBtn();
        }
        else if(prevURL)
        {
            history.replace(prevURL);
        }
        else if(history.length > 1)
        {

            let prevPath = history.location;
            history.goBack();
            setTimeout(()=>{
            let newPath = history.location;
                if(prevPath === newPath)
                {
                    history.replace('/');
                }
            },100)
        }
        else
        {
            history.replace("/");
        }
    }

    const [btnAreaWidth, setBtnAreaWidth] = useState(null);
    const [backBtnAreaWidth, setBackBtnAreaWidth] = useState(null);

    const btnAreaRef = useRef(null);
    const backBtnRef = useRef(null);
    const closeBtnRef = useRef(null);

    useEffect(() => {
        if (btnAreaRef?.current?.offsetWidth) {
            setBackBtnAreaWidth(btnAreaRef?.current?.offsetWidth);
        } else if (closeBtnRef?.current?.offsetWidth) {
            setBackBtnAreaWidth(closeBtnRef?.current?.offsetWidth);
        } else if (backBtnRef?.current?.offsetWidth) {
            setBtnAreaWidth(backBtnRef?.current?.offsetWidth);
        }
    }, []);

    const clickShareButton = async () =>{
        try
        {
            // if(userInfo['isMobile'] && userInfo['isApp'])
            // {
            //     if(userInfo['deviceType'] === 'iOS')
            //     {
            //         const currURL = window.location.href;
            //         if(navigator.share)
            //         {
            //             await navigator.share({
            //                 title: shareTitle,
            //                 url: `https://plink.motiners.com/?link=${currURL}&apn=com.motiners.bundle&isi=1556370860&ibi=com.motiners.motinersapp&st=${shareTitle}&sd=${shareDescription}&si=${shareImg}`
            //             })
            //         }
            //         else
            //         {
            //             kakaoButton.current.click();
            //         }
            //     }
            //     else
            //     {
            //         kakaoButton.current.click();
            //     }
            // }
            kakaoButton.current.click();
        }
        catch(error)
        {
            console.log(error);
        }
    }

    let btnArea = [];
    if(isShare === true || isDotBtn === true || showComplete === true || showExitBtn === true || isNotiBtn === true || isMatchingBtn === true)
    {
        btnArea.push(
            <Buttonarea key={'header-title-share-btn'} ref={btnAreaRef} width={btnAreaWidth}>
                {isShare ?
                (<Share onClick={clickShareButton}>
                                    <IconImg src={shareIcon} alt={'share button'}/>
                                    <Helmet>
                                        <script src="https://developers.kakao.com/sdk/js/kakao.js"></script>
                                    </Helmet>
                                    <KakaoShareButton 
                                        queryString={shareQueryString} 
                                        kakaoButton={kakaoButton}
                                        shareTitle={shareTitle}
                                        shareDescription={shareDescription}
                                        shareImg={shareImg}
                                    ></KakaoShareButton>
                                </Share>)
                :(null)}

                {isDotBtn ?
                <More onClick={handleModalState}>
                    <IconImg src={moreIconImg} />
                </More>
                : null}

                {/* WARN: 아이콘 크기 수정 안함 */}
                {showExitBtn ? (<ExitBtn onClick={(e)=>{if(onExit)onExit(e);}}><ExitBtnImg src={exitIcon} /></ExitBtn>):null}

                {/* WARN: 아이콘 크기 수정 안함 */}
                {isNotiBtn && isMatchingBtn? 
                    (userInfo['isLogin'] ?
                        (
                            <MatchingButtonBlock>
                                <MatchingBtn>
                                    <ButtonIcon src={onMatchingIcon}/>
                                </MatchingBtn>
                                <BellLink to={`/mypage/setting/alarm`}>
                                    <ButtonIcon src={bellIconImg} alt="motiners bell icon" />
                                    {newAlarmExist ? (<Alarm></Alarm>) : null}
                                </BellLink>
                            </MatchingButtonBlock>
                        ) : (
                            <MatchingButtonBlock>
                                <MatchingBtn>
                                    <ButtonIcon src={onMatchingIcon}/>
                                </MatchingBtn>
                                <BellLink to={`/social`}>
                                    <ButtonIcon src={bellIconImg} alt="motiners bell icon" />
                                </BellLink>
                            </MatchingButtonBlock>
                        )
                    ) : null}
                {
                    (showComplete)
                    ?(
                        <>
                        {
                            (isComplete)
                            ?(<CompleteBtn onClick={(e)=>{if(onCompleteClick) onCompleteClick();}}>완료</CompleteBtn>) 
                            : (<DisabledCompleteBtn>완료</DisabledCompleteBtn>)
                        }
                        </>
                    )
                    :(null)
                }
            </Buttonarea>
        );
    }

    let headerContent = [];
    if(isCloseBtn)
    {
        headerContent.push(
            <React.Fragment key={'header-title-content'}>
                <BackButtonarea ref={backBtnRef} width={backBtnAreaWidth}>
                </BackButtonarea>
                <Title>
                    <TitleTxt>{(title)?title:(<></>)}</TitleTxt>
                </Title>
                <CloseBtnArea ref={closeBtnRef}>
                    <CloseBtnWrapper onClick={goBack}>
                            <IconImg src={closeIcon} alt={'close page button'} />
                    </CloseBtnWrapper>
                </CloseBtnArea>
            </React.Fragment>
        );
    }
    else
    {
        headerContent.push(
            <React.Fragment key={'header-title-content'}>
                <BackButtonarea onClick={goBack} ref={backBtnRef} width={backBtnAreaWidth}>
                    <Back>
                        <IconImg src={backIconImg} alt={'move to previous page button'} />
                    </Back>
                </BackButtonarea>
                <Title>
                    <TitleTxt>{(title)?title:(<></>)}</TitleTxt>
                </Title>
            </React.Fragment>
        );    
            
    }
    
    return (
        <HeaderWrapper>
            <TopInner key={'header-type-title'} className={animationClassName} style={{borderBottom:borderbottom, background:background}} animation>
                {headerContent}
                {(isCloseBtn)?(null):(btnArea)}
            </TopInner>
        </HeaderWrapper>
    );
}


